import { MenuOptionType } from "@dexteel/mesf-core";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { TreeParameters } from "../models/TreeParameter";

type Props = {
	setDelayNodeSelectedInTree: (node: any | null) => void;
	setDelayCodeId: Function;
	setShowModal: (modal: "new" | "edit" | "delete" | "view" | "") => void;
	handleMoveUp: ({ delayCodeId }: { delayCodeId: number }) => void;
	handleMoveDown: ({ delayCodeId }: { delayCodeId: number }) => void;
};

export const useDelayCodeOptionsFunctions = ({
	setDelayNodeSelectedInTree,
	setDelayCodeId,
	setShowModal,
	handleMoveUp,
	handleMoveDown,
}: Props) => {
	const getMenuOptions = (data: TreeParameters) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Delay Code",
				key: "new_delay_code",
				onClick: () => {
					if (!data) {
						setDelayNodeSelectedInTree(null);
					}
					setShowModal("new");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Delay Code",
					key: "edit_delay_code",
					disabled: !data.isEditable,
					onClick: () => {
						setDelayCodeId(data.id);
						setShowModal("edit");
					},
					icon: <EditIcon />,
				},
				{
					name: "View Delay Code",
					key: "view_delay_code",
					onClick: () => {
						setDelayCodeId(data.id);
						setShowModal("view");
					},
					icon: <FindInPageIcon />,
				},
			]);
			if (!data.droppable) {
				options = options.concat([
					{
						name: "Delete Delay Code",
						key: "delete_delay_code",
						disabled: !data.isEditable,
						onClick: () => {
							setDelayCodeId(data.id);
							setShowModal("delete");
						},
						icon: <DeleteIcon />,
					},
					{
						name: "Move Up",
						key: "move_up_delay_code",
						disabled: data.isAtTop,
						onClick: () => {
							handleMoveUp({ delayCodeId: data.id });
						},
						icon: <ArrowUpwardIcon />,
					},
					{
						name: "Move Down",
						key: "move_down_delay_code",
						disabled: data.isAtBottom,
						onClick: () => {
							handleMoveDown({ delayCodeId: data.id });
						},
						icon: <ArrowDownwardIcon />,
					},
				]);
			}
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
